import { runWebinarNav } from '../../templates/common/webinar-nav/webinar-nav';
import {
  WEBINAR_TYPES,
  WEBINARS_DATA_KEY,
} from '../../scripts/config/constants';

const EVENT_WRAPPER_ATTR = 'data-webinar-events';
const RECORD_WRAPPER_ATTR = 'data-webinar-records';
const EVENT_ITEM_ATTR = 'data-webinar-hub-item';
const URL_PARAMS_SELECTOR_MAP = {
  [WEBINAR_TYPES.BUILDERS]: 'data-sf-link',
  [WEBINAR_TYPES.MULTIFAMILY]: 'data-mf-link',
  [WEBINAR_TYPES.PRO_INSTALLERS]: 'data-ci-link',
};
const URL_PARAMS_SELECTOR_LIST = Object.values(URL_PARAMS_SELECTOR_MAP);

export const initWebinarsHub = (pageType) => {
  runWebinarNav(pageType, [listenNavChanges]);

  const pageParamValue =
    new URL(window.location).searchParams.get(WEBINARS_DATA_KEY) || '';

  listenNavChanges(pageType, pageParamValue);
};

function listenNavChanges(pageType, pageParamValue = null) {
  let webinarLinksAttrs = findWebinarLinksAttrs(pageType);

  updateWebinarIndividualLinks(webinarLinksAttrs);

  // NOTE: if portal and search params value does not match when the page loads
  if (pageParamValue) {
    webinarLinksAttrs = findWebinarLinksAttrs(pageParamValue);
  }

  updateWebinarBlocksVisibility(`[${EVENT_WRAPPER_ATTR}]`, webinarLinksAttrs);
  updateWebinarBlocksVisibility(`[${RECORD_WRAPPER_ATTR}]`, webinarLinksAttrs);
}

function updateWebinarIndividualLinks(webinarLinksAttrs = []) {
  document.querySelectorAll(`[${EVENT_ITEM_ATTR}]`).forEach((item) => {
    const targetLinks = webinarLinksAttrs
      .map((attr) => item.getAttribute(attr))
      .filter(Boolean);

    if (targetLinks[0]) {
      item.href = targetLinks[0];
    }
  });
}

function updateWebinarBlocksVisibility(targetSelector, webinarLinksAttrs) {
  const blockWrapperEl = document.querySelector(targetSelector);
  const webinars = blockWrapperEl.querySelectorAll(`[${EVENT_ITEM_ATTR}]`);
  const hasActiveWebinars = Array.from(webinars).some((webinar) =>
    webinarLinksAttrs.some((webinarLinksAttr) =>
      webinar.getAttribute(`${webinarLinksAttr}`)
    )
  );

  blockWrapperEl.setAttribute(
    'style',
    `display:${hasActiveWebinars ? 'block' : 'none'}`
  );
}

function findWebinarLinksAttrs(webinarPortalType) {
  const activeFiltersList = (webinarPortalType || '')
    .split(',')
    .filter(Boolean);
  const individualLinksAttrList = (activeFiltersList || [])
    .map((value) => URL_PARAMS_SELECTOR_MAP[value])
    .filter(Boolean);

  return individualLinksAttrList.length > 0
    ? individualLinksAttrList
    : URL_PARAMS_SELECTOR_LIST;
}
